var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticStyle:{"height":"20px","width":"20px"},attrs:{"option":_vm.options,"init-options":{renderer: 'svg'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }